import React, { useEffect } from "react";
import Header from "../../components/header";
import "./empowerepage.css";
import HomeVideo from "../../assets/empower_background2.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import FeatureStories from "./stories";
import FlipCard from "./FlipCard";
import Empower from "../../assets/Empower_Rich_professional_young_Sri_Lankan_Vietnam_Ethiopian.webp";

import { ParallaxProvider } from "react-scroll-parallax";

//Charts
import EmpowerCharts from './EmpowerCharts';

export default function Homepage() {

  const handleScrollToNext = () => {
    const nextSection = document.getElementById("empower-our-people");
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ParallaxProvider>
      <div className="screen-page">
        <Header />
        {/* section 01 */}
        {/* home video */}
        <div style={{ position: "relative" }}>
          <div className="home-page-video">
            <div>
              <img
                src={HomeVideo}
                style={{ height: "calc(100vh - 120px)", width: "100%", objectFit: "cover" }}
                alt=""
              />
            </div>
          </div>

          {/* <div style={{ marginLeft: "20px" }}>
            <div className="empowere-video-text-box">
              <div className="video-background-text">
                <Parallax speed={10}>
                  <h1 className="empowere-topic-home">Empower</h1>
                </Parallax>
              </div>
            </div>
          </div> */}

           {/* White Box */}
           <div className="white-box">
              <div className="white-box-container">
                {/* <h1>
                  Modern <span className="white-box-container-h1">& Unique</span>
                </h1> */}
                <div className="screen-pc">
                  <h1 className="white-box-container-h1-text">
                    Empower <br />
                    {/* <span className="white-box-container-h1">Apparel Solutions</span> */}
                  </h1>
                </div>

                <div className="screen-mobile">
                  <p className="white-box-container-h1-text">
                    Empower <br />
                    {/* <span className="white-box-container-h1">
                      Apparel <br />
                      Solutions
                    </span> */}
                  </p>
                </div>

                {/* Button to scroll to the next section */}
                <div onClick={handleScrollToNext} className="scroll-button">
                  <FontAwesomeIcon icon={faArrowDown} style={{ fontSize: "16px" }} />
                </div>
              </div>
            </div>

          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "calc(100vh - 120px)",
              backgroundColor: "rgba(0, 0, 0, 0.15)",
              zIndex: 0,
            }}
          ></div>


          {/* H Letter Design */}
          <div className="h-banner-container">
            {/* Left Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-left"></div>
            </div>

            {/* Middle Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-design-N">
                <div className="h-left-N"></div>
                <div style={{ height: "350px" }} />
                <div className="h-right-N"></div>
              </div>
            </div>

            {/* Right Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-right"></div>
            </div>
          </div>

        </div>

        {/* section-2 */}
        {/* <div
          style={{ backgroundColor: "#f5f5f5", color: "#404040" }}
          className="empowerpage-para-conatiner"
        >
          <center>
            <div
              className="empowerpage-para"
              data-aos="fade-in"
              data-aos-duration="1000"
              data-aos-once="true"
              id="empower-our-people"
            >
              <h1>Empower <span className="white-box-container-h1">Our People</span></h1>
              <p>
                <span style={{ fontWeight:'bolder' }}>A LIFE WELL LIVED.</span>{" "}
                This is what we want for every single person at Hirdaramani. It
                is their ideas, passion, and commitment, that go into every
                garment we make. This makes our people our greatest asset and
                the lifeline of our organisation and this is why we’re deeply
                committed to uplifting, inspiring, and protecting them to ensure
                their overall wellbeing.
              </p>
              <p>
                Healthy and fair working conditions, a focus on equal
                opportunity, and personal wellbeing are the hallmarks of our
                Empower pillar. Our Wonders of Wellbeing program best
                exemplifies our commitment to the holistic wellbeing of everyone
                in our workforce.
              </p>
            </div>
          </center>
        </div> */}
        <div
          style={{ backgroundColor: "#f5f5f5", color: "#404040" }}
          className="empowerpage-para-container"
        >
          <div className="empowerpage-content">
            {/* Left Column - Text */}
            <div
              className="empowerpage-text"
              data-aos="fade-in"
              data-aos-duration="1000"
              data-aos-once="true"
              id="empower-our-people"
            >
              <h1>
                Empower <span className="white-box-container-h1">Our People</span>
              </h1>
              <p>
                <span style={{ fontWeight: "bolder" }}>A LIFE WELL LIVED.</span> This is
                what we want for every single person at Hirdaramani. It is their ideas,
                passion, and commitment, that go into every garment we make. This makes
                our people our greatest asset and the lifeline of our organisation and
                this is why we’re deeply committed to uplifting, inspiring, and
                protecting them to ensure their overall wellbeing.
              </p>
              <p>
                Healthy and fair working conditions, a focus on equal opportunity, and
                personal wellbeing are the hallmarks of our Empower pillar. Our Wonders
                of Wellbeing program best exemplifies our commitment to the holistic
                wellbeing of everyone in our workforce.
              </p>
            </div>

            {/* Right Column - Image */}
            <div className="empowerpage-image">
              <img
                src={Empower}
                alt="Empowering Our People"
                className="empower-image"
              />
            </div>
          </div>
        </div>


        {/* section-3 */}
        <div className="empower-card">
          <div className="para-box">
            <div data-aos="fade-up-left" data-aos-duration="500">
              <h2 className="para-one-1">
                In our Future First roadmap, we concentrate
              </h2>
              <h2 className="para-one-2">
                our Empower principles across three main areas:
              </h2>
            </div>
            <div data-aos="zoom-in">
              <h1 className="empower-para-two">EMPOWER</h1>
            </div>
            <div className="empower-flip-part">
              <FlipCard />
            </div>
          </div>
        </div>

        {/* section-4 */}
        <FeatureStories />

        {/* Section-5 */}
        <EmpowerCharts />
      </div>
    </ParallaxProvider>
  );
}
